import React from 'react';
import { LayoutDashboard, Package, ShoppingBag, MessageSquare, Settings } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
import { Screen } from '../../types';
export function VendorBottomNav() {
  const {
    currentScreen,
    resetTo
  } = useNavigation();
  const navItems = [{
    screen: Screen.VENDOR_DASHBOARD,
    icon: LayoutDashboard,
    label: 'Dashboard'
  }, {
    screen: Screen.VENDOR_ORDERS,
    icon: Package,
    label: 'Orders'
  }, {
    screen: Screen.VENDOR_PRODUCTS,
    icon: ShoppingBag,
    label: 'Products'
  }, {
    screen: Screen.VENDOR_MESSAGES,
    icon: MessageSquare,
    label: 'Messages'
  }, {
    screen: Screen.VENDOR_STORE_SETTINGS,
    icon: Settings,
    label: 'Settings'
  }];
  return <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-6 py-3 pb-safe z-[60] pointer-events-auto" data-id="element-158">
      <div className="flex justify-between items-center max-w-md mx-auto" data-id="element-159">
        {navItems.map(item => {
        const isActive = currentScreen === item.screen;
        const Icon = item.icon;
        return <button key={item.label} onClick={() => resetTo(item.screen)} className="flex flex-col items-center justify-center gap-1 min-w-[60px] cursor-pointer active:scale-95 transition-transform touch-manipulation" data-id="element-160">
              <div className={`p-1.5 rounded-xl transition-colors ${isActive ? 'text-primary' : 'text-gray-400'}`} data-id="element-161">
                <Icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} data-id="element-162" />
              </div>
              <span className={`text-[10px] font-medium transition-colors ${isActive ? 'text-primary' : 'text-gray-500'}`} data-id="element-163">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}